import styled from 'styled-components';

export const DropdownMenuDivider = styled.hr`
  background: var(--border-default);
  border: 0;
  height: 0.0625rem;
  margin: var(--spacing-2) var(--spacing-1);
`;
